(() => {
  const arrange = () => {
    const backdrop = document.querySelector('.ze-pdp-backdrop');
    const main = document.querySelector('#MainContent');
    if (!backdrop || !main || main.dataset.zeLayoutReady) return;
    const q = s => main.querySelector(s);
    const hero = q('.pdp2__hero,.elite2-hero,.c2hero-main') || q('product-info .product');
    if (!hero) return;
    main.dataset.zeLayoutReady = 'true';
    document.body.classList.add('ze-pdp-compact');
    // Keep the gallery and highlights together, but let reviews use both columns.
    const grid = q('.elite2-hero__grid');
    if (grid) {
      const column = document.createElement('div');
      column.className = 'ze-pdp-media-column';
      grid.prepend(column);
      grid.classList.add('ze-pdp-balanced');
      ['.elite2-gallery','.elite2-facts'].forEach(s => { const node = grid.querySelector(s); if(node) column.append(node); });
    }
    const mediaColumn = q('.ze-pdp-media-column,.c2hero-media-column,.ze-bar-media-column');
    if (mediaColumn) {
      const measure = () => mediaColumn.style.setProperty('--ze-media-height',mediaColumn.offsetHeight+'px');
      new ResizeObserver(measure).observe(mediaColumn); measure();
    }
    let proof = q('.elite2-proof:not(.elite2-proof--later),.collagen2-reviews,.electro2-proof,.pdp2-proof-block');
    if (proof) {
      proof.classList.add('ze-pdp-wide-proof');
      hero.after(proof);
      const later = q('.elite2-proof--later');
      if (proof.matches('.elite2-proof') && later) {
        const quote = later.querySelector('article');
        const body = proof.querySelector('.elite2-proof__grid');
        if (quote && body) { body.insertBefore(quote,body.querySelector(':scope > a')); later.remove(); }
      }
    }
    const oldNav = q('.pdp2-page-nav,.collagen2-jump,.electro2-jump,.elite2-jump');
    const nav = document.createElement('nav');
    nav.className = 'ze-pdp-section-nav';
    nav.setAttribute('aria-label', backdrop.dataset.navLabel);
    const inner = document.createElement('div');
    inner.className = 'ze-pdp-section-nav__inner';
    nav.append(inner);
    const used = new Set();
    const add = (target,label) => {
      if (!target || !label || used.has(target)) return;
      used.add(target);
      if (!target.id) target.id = 'ze-pdp-section-' + used.size;
      target.classList.add('ze-pdp-nav-target');
      const a = document.createElement('a');
      a.href = '#' + target.id; a.textContent = label;
      inner.append(a);
    };
    if (oldNav) {
      oldNav.querySelectorAll('a[href^="#"]').forEach(a => add(document.getElementById(a.hash.slice(1)),a.textContent.trim()));
      oldNav.remove();
    } else {
      [
        ['.ze-inside','inside'],
        ['.elite2-taste','taste'],
        ['.elite2-vitamins','highlights'],
        ['.elite2-enjoy','enjoy'],
        ['.elite2-ingredients,.collagen2-ingredients,.electro2-ingredients','ingredients'],
        ['.elite2-nutrition,.collagen2-label,.electro2-label','nutrition'],
        ['.elite2-faq,.collagen2-faq,.electro2-faq','faq'],
        ['.product__description','details']
      ].forEach(([s,label]) => add(q(s),backdrop.dataset[label]));
    }
    // Include nutrition and FAQ on templates whose old menus omitted them.
    add(q('.collagen2-label,.electro2-label'),backdrop.dataset.nutrition);
    add(q('.pdp2-faq'),backdrop.dataset.faq);
    const reviewTarget = q('#judgeme_product_reviews,.jdgm-review-widget');
    if (![...inner.children].some(a => a.textContent === backdrop.dataset.reviews)) add(reviewTarget,backdrop.dataset.reviews);
    if (!inner.children.length) add(hero,backdrop.dataset.details);
    (proof || hero).after(nav);
    const reviewLink = [...inner.children].find(a => a.textContent === backdrop.dataset.reviews);
    if (reviewLink) inner.append(reviewLink);
    const links = [...inner.querySelectorAll('a')];
    links.forEach(a => a.addEventListener('click',() => {
      links.forEach(link => link.removeAttribute('aria-current'));
      a.setAttribute('aria-current','location');
    }));
    // Active section indicator also follows ordinary scrolling.
    const observer = new IntersectionObserver(entries => {
      const visible = entries.filter(e => e.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top)[0];
      if (!visible) return;
      links.forEach(a => {
        if (a.hash === '#' + visible.target.id) a.setAttribute('aria-current','location');
        else a.removeAttribute('aria-current');
      });
    },{rootMargin:'-15% 0px -65% 0px'});
    used.forEach(el=>observer.observe(el));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',arrange,{once:true});
  else arrange();
  document.addEventListener('shopify:section:load',arrange);
})();
